import { createClientSearchPage, includesSearch } from "../../../shared/api/client-search-page";
import { createSearchExport } from "../../../shared/api/ui/common/search-export";
import { GET_ALL_BOOTH } from "../../../shared/api/endpoints";
export const requestBoothPage = createClientSearchPage((row, term) =>
  includesSearch([row.id, row.title, row.description, row.website, row.webSite], term));
export const requestBoothExport = createSearchExport(GET_ALL_BOOTH, requestBoothPage);
